module.exports = __webpack_public_path__ + "img/right-indent-01.9053de79.svg";